import React, { useState } from "react";
import PropTypes from "prop-types";
import { LogoWrapper } from "./styled";
import { Link } from "react-router-dom";
import Config from "config";

const Logo = ({ src, alt = "" }) => {
  const transporteurLogoUrl = `${Config.get("cake_url")}/img/logo-header.png`;
  const [logoHeaderExists, setLogoHeaderExists] = useState(true);

  const handleLogoError = () => {
    setLogoHeaderExists(false);
  };

  return (
    <LogoWrapper>
      <Link className="logoLink" to="/">
        <img className="logoImg" src={src} alt={alt} />
        {logoHeaderExists && (
          <>
            <span className="forText">for</span>
            <img
              className="transporteurLogoImg"
              src={transporteurLogoUrl}
              alt="Logo Transporteur"
              onError={handleLogoError}
            />
          </>
        )}
      </Link>
    </LogoWrapper>
  );
};

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default Logo;
